import { trpc } from '@/App'
import FreeTrialEnding from '@/components/FreeTrialEnding'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/shadcn/tooltip'
import { useTimeSavedCounter } from '@/hooks/useTimeSaved'
import useUserPermissions from '@/hooks/useUserPermissions'
import { featureFlagKeys } from '@/utils/data/featureFlags'
import { useRouterState } from '@tanstack/react-router'
import { useFeatureFlagEnabled } from 'posthog-js/react'
import { useEffect, useState } from 'react'
import { useLocalStorage } from 'usehooks-ts'
import SearchBarAndDialog from '../SearchBarAndDialog'

export const CreativeOsHeader = () => {
  const [upgradeDialogOpen, setUpgradeDialogOpen] = useState<boolean>(false)
  const [welcomeSearchVisible] = useLocalStorage<boolean>('welcome_search_visible', true)
  const { permissions: permissionData } = useUserPermissions()
  const { data: authUser } = trpc.me.useQuery(null)
  const { data: timeSavedCounter } = useTimeSavedCounter()

  const getGreeting = () => {
    const hour = new Date().getHours()

    if (hour < 12) return 'Good morning'
    if (hour < 18) return 'Good afternoon'
    return 'Good evening'
  }

  const routerState = useRouterState()

  const welcomeScreenFlagEnabled = useFeatureFlagEnabled(featureFlagKeys.welcomeScreen)

  const [isOnTemplatePage, setIsOnTemplatePage] = useState(false)

  useEffect(() => {
    setIsOnTemplatePage(routerState.location.pathname.startsWith('/feeds/templates'))
  }, [routerState.location.pathname])

  return (
    <>
      {upgradeDialogOpen && permissionData && (
        <FreeTrialEnding
          open={upgradeDialogOpen}
          onOpenChange={() => setUpgradeDialogOpen(false)}
          permissionData={permissionData}
        />
      )}
      <div className={`flex items-center justify-between gap-3 w-full bg-themebackground dark:bg-themebackgrounddark `}>
        <div className="hidden lg:flex items-center w-1/3">
          <h5
            className={`${isOnTemplatePage && welcomeScreenFlagEnabled ? 'hidden lg:flex' : 'hidden'} font-bold text-2xl`}
          >
            {getGreeting()}, {authUser?.firstName}.
          </h5>
        </div>
        {welcomeSearchVisible && isOnTemplatePage ? null : <SearchBarAndDialog />}
        <div className="hidden lg:flex justify-end items-center w-1/3">
          <div
            onClick={() => window.location.reload()}
            className="w-full gap-2 flex justify-end items-center min-h-10 cursor-pointer"
          >
            {timeSavedCounter && timeSavedCounter.monthlyTimeSaved !== 0 && timeSavedCounter.totalSavedTime !== 0 ? (
              <div className={'flex gap-2'}>
                <span className={'font-light text-xs text-thememutedforeground dark:text-white'}>
                  You’ve saved{' '}
                  <span className="bg-purple-50 rounded-full font-medium p-1.5 text-themedestructive dark:text-black">
                    {timeSavedCounter.monthlyTimeSaved} hours
                  </span>{' '}
                  this month ({timeSavedCounter.totalSavedTime} Total){' '}
                  <Tooltip>
                    <TooltipTrigger className="ml-1">{'ⓘ'}</TooltipTrigger>
                    <TooltipContent className="max-w-sm">
                      <p>
                        You’ve saved {timeSavedCounter.monthlyTimeSaved} hours this month and{' '}
                        {timeSavedCounter.totalSavedTime} hours all time by using CreativeOS templates
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </span>
              </div>
            ) : null}
            <img alt={'CreativeOS'} src={'/images/icon_no_bg.png'} className={'h-9 dark:block hidden'} />
            <img alt={'CreativeOS'} src={'/images/icon_no_bg.png'} className={'h-9 dark:hidden block'} />
          </div>
        </div>
      </div>
    </>
  )
}
